import { Button } from "antd";
import styled, { css } from "styled-components";

export const StyledButton = styled(Button)<{
    margin?: string;
    marginTop?: string;
    marginBottom?: string;
    marginLeft?: string;
    marginRight?: string;
    bgColor?: "success";
}>`
    height: 50px;
    border-radius: 50px;
    width: 100%;
    font-size: 16px;
    flex-shrink: 0;

    ${({ bgColor, theme }) => {
        if (bgColor === "success") {
            return css`
                background-color: ${theme.colors.green};

                &:hover {
                    background-color: color-mix(
                        in srgb,
                        ${theme.colors.green} 85%,
                        black
                    ) !important;
                }

                &:active {
                    background-color: color-mix(
                        in srgb,
                        ${theme.colors.green} 75%,
                        black
                    ) !important;
                }
            `;
        }
    }}

    ${({ margin }) => margin && `margin: ${margin};`}
    ${({ marginTop }) => marginTop && `margin-top: ${marginTop};`}
    ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}
    ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`}
    ${({ marginRight }) => marginRight && `margin-right: ${marginRight};`}
`;
